import { updateUserAdminEmployerClientSchema } from '../shared/validations/userValidations';
import { AddressFields } from './AddressForm';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { useAuth } from '../utils/AuthContext.js';
import { useLanguage } from '../utils/LanguageContext';
import translations from './ComponentsTranslations.lang.json';
import { Alert } from 'antd';

const AdminEmployerForm = ({ onFinish, submitLabel }) => {
  const { lang } = useLanguage(translations);
  const { user, api } = useAuth();

  const { employerName, employerAddress } = user.adminEmployer || {};

  return (
    <ValidatedForm
      key="adminEmployer"
      schema={updateUserAdminEmployerClientSchema}
      initialValues={{ adminEmployer: { employerName, employerAddress } }}
      handleSubmit={api.updateUserAdminEmployer}
      onFinish={onFinish}
    >
      <Alert type="info" message={lang('adminEmployerExplainerNote')} />
      <FormInput name="adminEmployer.employerName" type="text" />
      <AddressFields prefix="adminEmployer.employerAddress" />
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  );
};

export default AdminEmployerForm;
